import React, { useEffect, useState } from "react";

const DelegateStructTreeItem = ({ item, selectedId, onSelect, selectedIdPath }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isInPath = Boolean(selectedIdPath && selectedIdPath.length && selectedIdPath.includes(item.id));

    useEffect(() => {
        if (isInPath) setIsOpen(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInPath]);

    function toggleHandler(event) {
        event.stopPropagation();
        setIsOpen((prev) => !prev);
    }

    function selectHandler() {
        onSelect(item);
    }

    return (
        <div>
            <div
                onClick={selectHandler}
                className={[
                    "delegate-struct-tree__item",
                    isInPath && "delegate-struct-tree__item--selected",
                ].filter(Boolean).join(" ")}
            >
                {
                    item.children.length
                        ? <span
                            onClick={toggleHandler}
                            className={`delegate-struct-tree__item__arrow${isOpen ? "--open" : ""}`}
                        ></span>
                        : <span className={"delegate-struct-tree__item__buffer"}></span>
                }
                {item.name}
                {
                    selectedId === item.id
                        ? <span className={"delegate-struct-tree__item__check"}></span>
                        : null
                }
            </div>
            {
                item.children.length ? (
                    <div
                        className={`delegate-struct-tree__sub-menu${isOpen ? "" : " delegate-struct-tree__sub-menu--hidden"}`}
                    >
                        {
                            item.children.map((subItem) => (
                                <DelegateStructTreeItem
                                    key={subItem.id}
                                    item={subItem}
                                    selectedId={selectedId}
                                    onSelect={onSelect}
                                    selectedIdPath={selectedIdPath}
                                />
                            ))
                        }
                    </div>
                ) : null
            }
        </div>
    );
};

export default DelegateStructTreeItem;